import React, { useState, useRef, FunctionComponent, PropsWithChildren } from "react";
import { ModalContainer, ModalContainerContent, ModalContainerDraggableControl } from "./styles";

interface ModalBoxProps extends PropsWithChildren {
  showModal: boolean;
  closeModal: () => void;
}
const ModalBox: FunctionComponent<ModalBoxProps> = ({ showModal, closeModal, children }) => {
  const [y, setY] = useState(0);
  const startY = useRef<number | null>(null);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    startY.current = e.touches[0].clientY - y; // store initial offset
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (startY.current !== null) {
      const newY = e.touches[0].clientY - startY.current;
      if (newY >= 0) setY(newY); // only allow downward drag
    }
  };

  const handleTouchEnd = () => {
    // Example snap-back behavior
    if (y < 100) {
      setY(0); // snap back if not dragged enough
    } else {
      closeModal();
    }
    startY.current = null;
  };

  return (
    <ModalContainer
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      $show={showModal}
      onClick={(e) => e.stopPropagation()}
    >
      <ModalContainerDraggableControl />
      <ModalContainerContent id="modal-content-div">{showModal && children}</ModalContainerContent>
    </ModalContainer>
  );
};

export default ModalBox;
